import { render, staticRenderFns } from "./PortalButton.vue?vue&type=template&id=14d29ff6&scoped=true&"
import script from "./PortalButton.vue?vue&type=script&lang=js&"
export * from "./PortalButton.vue?vue&type=script&lang=js&"
import style0 from "./PortalButton.vue?vue&type=style&index=0&id=14d29ff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d29ff6",
  null
  
)

export default component.exports